import { render, staticRenderFns } from "./FilterChips.vue?vue&type=template&id=4f09bf5b&"
import script from "./FilterChips.vue?vue&type=script&lang=js&"
export * from "./FilterChips.vue?vue&type=script&lang=js&"
import style0 from "./FilterChips.vue?vue&type=style&index=0&id=4f09bf5b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports